import {Icon, styled, theme} from "@reside/ui";

export const StarIcon = styled(Icon)<{isLoading: boolean; isHovered: boolean}>`
  cursor: ${({isLoading}) => (isLoading ? "not-allowed" : "pointer")};

  margin-left: -0.4em;
  margin-right: 8px;
  height: fit-content;

  &:before {
    background-color: ${({isHovered}) =>
      isHovered ? theme.colors.borderLightGray : "transparent"};
    border-radius: 50%;
    padding: 4px;
  }

  @media (max-width: 768px) {
    margin-right: 4px;
  }
`;
